import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import RatingStars from 'generic/RatingStars';
import RotatingBanner from './components/RotatingBanner';

import type { ComponentsLogoBanner } from 'queries/graphql';

import styles from './styles.module.scss';

export default function LogosBanner({
  sectionId,
  overlayText,
  logos,
  style,
}: ComponentsLogoBanner) {
  const { starColor, backgroundColor, textColor, textFont } = style || {};

  const textFontOverrides = useTextFontOverrides(textFont);

  return (
    <div id={sectionId} className={`root ${styles.main} logosBanner`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      <div className={styles.overlay_text_container}>
        <div className={styles.overlay_text_wrapper}>
          <div className={styles.stars_wrapper}>
            <RatingStars rating={5} style={{ starColor }} className={styles.stars} />
          </div>
          {overlayText && (
            <div className={styles.overlay_text}>
              <p>{overlayText}</p>
            </div>
          )}
        </div>
      </div>
      {logos && <RotatingBanner images={logos} styles={styles} />}
    </div>
  );
}
